<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">

<!--      <a-form-model-item label="学员头像" prop="avatar" >-->
<!--        <a-input v-model="form.avatar" placeholder="请输入学员头像" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="学员头像" prop="avatar">
        <file-upload type="image" :defaultList="form.imgArr" :count="1" :imgSize="'180*240'"
                     @input="getImg($event, 'avatar')"></file-upload>
      </a-form-model-item>

      <a-form-model-item label="学员视频" prop="video" >
        <file-upload   type="file" :defaultList="form.videoArr" :count="form.videoCount"
                       @input="getImg($event, 'video')"></file-upload>

        <video v-if="form.video"  style="width: 180px;height: 120px"
               class="avatar video-avatar"
               controls="controls"  :src="form.videoArr[0].url"/>
      </a-form-model-item>


      <a-form-model-item label="年限(系统训练)" prop="year" >
        <a-input v-model="form.year" placeholder="请输入年限(系统训练)" />
      </a-form-model-item>
      <a-form-model-item label="训练内容" prop="trainContent" >
        <a-input v-model="form.trainContent" placeholder="请输入训练内容" />
      </a-form-model-item>
      <a-form-model-item label="每周训练次数" prop="week" >
        <a-input v-model="form.week" placeholder="请输入每周训练次数" />
      </a-form-model-item>
      <a-form-model-item label="每次训练时间(单位 小时)" prop="frequency" >
        <a-input v-model="form.frequency" placeholder="请输入每次训练时间(单位 小时)" />
      </a-form-model-item>
      <a-form-model-item label="训练总时长(单位 月)" prop="moon" >
        <a-input v-model="form.moon" placeholder="请输入训练总时长(单位 月)" />
      </a-form-model-item>
      <a-form-model-item label="训练目标" prop="target" >
        <a-input v-model="form.target" placeholder="请输入训练目标" />
      </a-form-model-item>
      <a-form-model-item label="训练前体重" prop="weight" >
        <a-input v-model="form.weight" placeholder="请输入训练前体重" />
      </a-form-model-item>
      <a-form-model-item label="训练前腰围" prop="waistline" >
        <a-input v-model="form.waistline" placeholder="请输入训练前腰围" />
      </a-form-model-item>
      <a-form-model-item label="训练前臀围" prop="hipline" >
        <a-input v-model="form.hipline" placeholder="请输入训练前臀围" />
      </a-form-model-item>
      <a-form-model-item label="训练前图片" prop="picture" >
        <file-upload type="image" :defaultList="form.imgArr1" :count="1" :imgSize="'345*292'"
                     @input="getImg($event, 'picture')"></file-upload>

      </a-form-model-item>
      <a-form-model-item label="训练后体重" prop="trainWeight" >
        <a-input v-model="form.trainWeight" placeholder="请输入训练后体重" />
      </a-form-model-item>
      <a-form-model-item label="训练后腰围" prop="trainWaistline" >
        <a-input v-model="form.trainWaistline" placeholder="请输入训练后腰围" />
      </a-form-model-item>
      <a-form-model-item label="训练后臀围" prop="trainHipline" >
        <a-input v-model="form.trainHipline" placeholder="请输入训练后臀围" />
      </a-form-model-item>
      <a-form-model-item label="训练后图片" prop="trainPicture" >
        <file-upload type="image" :defaultList="form.imgArr2" :count="1" :imgSize="'345*292'"
                     @input="getImg($event, 'trainPicture')"></file-upload>


      </a-form-model-item>
      <a-form-model-item label="门店名称" prop="shopId" >
<!--        <a-input v-model="form.shopId" placeholder="请选择门店名称" />-->
        <a-select placeholder="全部" v-model:value="form.shopId"
     @change="oncoachList">
          <a-select-option v-model:value="item.id" v-for="(item, index) in courseList" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>

      </a-form-model-item>
      <a-form-model-item label="执教教练" prop="coachId" >
        <a-select placeholder="全部" show-search v-model:value="form.coachId" @change="oncoachList"
                  option-filter-prop="children" :filterOption="filterOption">
          <a-select-option v-model:value="item.id" v-for="(item, index) in coachList" :key="index">
            {{ item.nickname }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="学员名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入学员名称" />
      </a-form-model-item>
      <a-form-model-item label="内容" prop="content" >
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getStudent, addStudent, updateStudent, shopName, coachName} from '@/api/student/student'
import Editor from '@/components/Editor'
import {courseName} from "@/api/catalogue/catalogue";
import {guid} from "@/utils/ruoyi";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      videoArr: [],
      courseList:[],
      coachList:[],
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        imgArr: [],
        imgArr1: [],
        imgArr2: [],

        shopId: null,

        avatar: null,
        video: null,

        year: null,

        trainContent: null,

        week: null,

        frequency: null,

        moon: null,

        target: null,

        weight: null,

        waistline: null,

        hipline: null,

        picture: null,

        trainWeight: null,

        trainWaistline: null,

        trainHipline: null,

        trainPicture: null,

        coachId: null,

        name: null,

        content: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        // shopId: [
        //   { required: true, message: '门店ID，外键{shop.id}不能为空', trigger: 'blur' }
        // ],
        avatar: [
          { required: true, message: '学员头像不能为空', trigger: 'blur' }
        ],
        year: [
          { required: true, message: '年限(系统训练)不能为空', trigger: 'blur' }
        ],
        trainContent: [
          { required: true, message: '训练内容不能为空', trigger: 'blur' }
        ],
        week: [
          { required: true, message: '每周训练次数不能为空', trigger: 'blur' }
        ],
        frequency: [
          { required: true, message: '每次训练时间(单位 小时)不能为空', trigger: 'blur' }
        ],
        moon: [
          { required: true, message: '训练总时长(单位 月)不能为空', trigger: 'blur' }
        ],
        target: [
          { required: true, message: '训练目标不能为空', trigger: 'blur' }
        ],
        weight: [
          { required: true, message: '训练前体重不能为空', trigger: 'blur' }
        ],
        waistline: [
          { required: true, message: '训练前腰围不能为空', trigger: 'blur' }
        ],
        hipline: [
          { required: true, message: '训练前臀围不能为空', trigger: 'blur' }
        ],
        picture: [
          { required: true, message: '训练前图片不能为空', trigger: 'blur' }
        ],
        trainWeight: [
          { required: true, message: '训练后体重不能为空', trigger: 'blur' }
        ],
        trainWaistline: [
          { required: true, message: '训练后腰围不能为空', trigger: 'blur' }
        ],
        trainHipline: [
          { required: true, message: '训练后臀围不能为空', trigger: 'blur' }
        ],
        trainPicture: [
          { required: true, message: '训练后图片不能为空', trigger: 'blur' }
        ],

        name: [
          { required: true, message: '学员名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    filterOption(input, option) {
      console.log(input, option,"input, option")
      // 重点在这
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.videoArr= [],
      this.form = {
        id: null,
        imgArr: [],
        imgArr1: [],
        imgArr2: [],
        videoArr: [],
        shopId: null,
        video: null,
        year: null,
        trainContent: null,
        week: null,
        frequency: null,
        moon: null,
        target: null,
        weight: null,
        waistline: null,
        hipline: null,
        picture: null,
        trainWeight: null,
        trainWaistline: null,
        trainHipline: null,
        trainPicture: null,
        coachId: null,
        avatar: null,
        name: null,
        content: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.getCourseList()
      console.log(this.form.shopId,"this.form.shopId")
      this.getcoachList(this.form.shopId)
    },
    oncoachList(val){
      this.getcoachList(val)
    },
    /** 查询门店名称 */
    getCourseList() {
      shopName().then(Response => {
          console.log(Response)
          this.courseList = Response.data
        }
      )
    },

    /** 查询教练名称 */
    getcoachList(shopId) {
      coachName({shopId:shopId}).then(Response => {
          console.log(Response)
          this.coachList = Response.data
        }
      )
    },

    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.getCourseList()
      this.getcoachList(this.form.shopId)
      this.formType = 2
      const id = row ? row.id : ids
      getStudent({"id":id}).then(response => {
        this.form = response.data

        let that = this;
        this.form.imgArr = []
        this.form.imgArr.push({
          uid: guid(8, 10),
          name: that.form.avatar,
          status: 'done',
          halfUrl: that.form.avatar,
          url: that.form.avatar,
          path: that.form.avatar
        })

        this.form.imgArr1 = []
        this.form.imgArr1.push({
          uid: guid(8, 10),
          name: that.form.picture,
          status: 'done',
          halfUrl: that.form.picture,
          url: that.form.picture,
          path: that.form.picture
        })

        this.form.imgArr2 = []
        this.form.imgArr2.push({
          uid: guid(8, 10),
          name: that.form.trainPicture,
          status: 'done',
          halfUrl: that.form.trainPicture,
          url: that.form.trainPicture,
          path: that.form.trainPicture
        })

        this.form.videoArr = []
        this.form.videoArr.push({
          uid: guid(8, 10),
          name: that.form.video,
          status: 'done',
          halfUrl: that.form.video,
          url: that.form.video,
          path: that.form.video
        })


        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateStudent(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addStudent(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    /******************** 上传图片数据处理 start ********************/
    /**前端 需要将图片格式处理成数组，方便数据回显 */
    setImgData(field, img) {
      let fieldImgArr = []
      if (img.indexOf(",") === -1) {
        // 单图
        if (this.form[`${field}Count`] === 1) {
          if (img) {
            fieldImgArr.push({
              uid: guid(8, 10),
              name: img,
              status: 'done',
              halfUrl: img,
              url: img,
              path: img
            })
          }
        }
      } else {
        // 多图
        if (this.form[`${field}Count`] > 1) {
          let imgArr = img.split(",")
          if (imgArr.length) {
            imgArr.map(item => {
              fieldImgArr.push({
                uid: guid(8, 10),
                name: img,
                status: 'done',
                halfUrl: img,
                url: item,
                path: item
              })
            })
          }
        }
      }
      return fieldImgArr
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    /** 点击视频 弹窗打窗口播放视频*/
    async handlePreview(file) {
      this.previewImage = this.form.video || file.video;
      this.previewVisible = true;
      this.$nextTick(() => {
        this.$refs.myVideo.play()
      })
    },
    handleCancel() {
      this.previewVisible = false;
    },
    /******************** 上传图片数据处理 end   ********************/
  }
}
</script>
